/* ORA INHALE — Navigation JS */
(function () {
  'use strict';

  const toggle   = document.getElementById('ora-menu-toggle');
  const menu     = document.getElementById('ora-menu');
  const overlay  = document.getElementById('ora-overlay');
  const closeBtn = document.getElementById('ora-menu-close');

  if (!toggle || !menu) return;

  function openMenu() {
    menu.classList.add('is-open');
    overlay.classList.add('is-open');
    menu.setAttribute('aria-hidden', 'false');
    overlay.setAttribute('aria-hidden', 'false');
    toggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';

    // Focus premier lien du menu
    const firstLink = menu.querySelector('.ora-menu__link');
    if (firstLink) setTimeout(() => firstLink.focus(), 320);
  }

  function closeMenu() {
    menu.classList.remove('is-open');
    overlay.classList.remove('is-open');
    menu.setAttribute('aria-hidden', 'true');
    overlay.setAttribute('aria-hidden', 'true');
    toggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    toggle.focus();
  }

  toggle.addEventListener('click', openMenu);
  if (closeBtn) closeBtn.addEventListener('click', closeMenu);
  if (overlay) overlay.addEventListener('click', closeMenu);

  // Fermer avec Escape
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && menu.classList.contains('is-open')) {
      closeMenu();
    }
  });

  // ─── Mise à jour compteur panier ────────────────────────
  function updateCartBadges(count) {
    const badges = document.querySelectorAll(
      '#ora-cart-count, #ora-bottom-cart-count'
    );
    badges.forEach((badge) => {
      badge.textContent = count;
      if (count > 0) badge.removeAttribute('hidden');
      else badge.setAttribute('hidden', '');
    });

    // Mettre à jour l'aria-label du lien panier
    const cartLink = document.getElementById('ora-cart-link');
    if (cartLink) {
      cartLink.setAttribute(
        'aria-label',
        `Panier (${count} article${count !== 1 ? 's' : ''})`
      );
    }
  }

  // Écouter les mises à jour panier de Dawn (pubsub)
  document.addEventListener('cart:updated', (e) => {
    if (e.detail && typeof e.detail.item_count !== 'undefined') {
      updateCartBadges(e.detail.item_count);
    }
  });

  // Hook sur le pubsub de Dawn si disponible
  if (typeof window.subscribe === 'function') {
    window.subscribe('cart-update', (event) => {
      if (event && event.cart) {
        updateCartBadges(event.cart.item_count);
      }
    });
  }

  // ─── Active state bottom nav via URL ────────────────────
  const path = window.location.pathname;
  const navItems = document.querySelectorAll('.ora-bottom-nav__item[href]');
  navItems.forEach((item) => {
    const href = item.getAttribute('href');
    if (!href) return;
    if (href === '/' && path === '/') {
      item.classList.add('is-active');
    } else if (href !== '/' && path.startsWith(href)) {
      item.classList.add('is-active');
    }
  });
})();
